import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-search',
  templateUrl: './project-search.component.html',
})
export class ProjectSearchComponent {

}
